import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import type { Config, Id } from '../config';
import css from './contributors.module.scss';
interface Props {
  sections: Config;
  selected: Id;
  onSelect(id: Id): void;
}
export function Contributors(t0) {
  const $ = _c(7);
  const {
    sections,
    selected,
    onSelect
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className={css.heading}>Key contributors</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== sections) {
    t2 = Object.entries(sections);
    $[1] = sections;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onSelect || $[4] !== selected || $[5] !== t2) {
    t3 = <aside className={css.wrapper}>{t1}<ul className={css.list}>{t2.map(t4 => {
          const [, t5] = t4;
          const {
            id,
            title,
            status,
            icon,
            count,
            subtitle
          } = t5;
          return <li key={id}><button onClick={() => onSelect(id)} className={cn(css.item, {
              [css.active]: selected === id
            })}><span className={css.icon}>{icon}</span><span className={css.text}><span className={css.title}>{title}</span><span className={css.subtitle}>{subtitle}</span></span>{id === "raw" ? <span className={css.link}>View raw key ›</span> : <span className={cn(css.meta, {
                [css.error]: status === "error",
                [css.warning]: status === "warning"
              })}><span className={cn(css.badge, {
                  [css.error]: status === "error",
                  [css.warning]: status === "warning"
                })}>{status === "success" ? "\u2713" : status === "warning" ? "!" : "\u2715"}</span><span className={css.count}>{count}</span></span>}</button></li>;
        })}</ul></aside>;
    $[3] = onSelect;
    $[4] = selected;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}